import { Link } from 'react-router-dom';
import { Shield, Home, ChevronRight, Mail, MapPin, ExternalLink } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-white pt-20">
      {/* Breadcrumb */}
      <div className="bg-slate-100 border-b border-slate-200">
        <div className="container-custom py-3">
          <nav className="flex items-center gap-2 text-sm" aria-label="Breadcrumb">
            <Link to="/" className="flex items-center gap-1 text-slate-500 hover:text-blue-600 transition-colors">
              <Home className="w-4 h-4" />
              <span>Kryefaqja</span>
            </Link>
            <ChevronRight className="w-4 h-4 text-slate-400" />
            <span className="text-slate-900 font-medium">Politika e Privatësisë</span>
          </nav>
        </div>
      </div>
      
      {/* Header */}
      <section className="py-12 bg-slate-50 border-b border-slate-200">
        <div className="container-custom">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-blue-100 flex items-center justify-center">
              <Shield className="w-7 h-7 text-blue-600" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-slate-900 font-['Inter_Tight']">
                Politika e Privatësisë
              </h1>
              <p className="text-slate-500 mt-1">Përditësimi i fundit: 13 Shkurt 2026</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Content */}
      <section className="py-12">
        <div className="container-custom max-w-4xl">
          <div className="prose prose-slate max-w-none">
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">1. Informacion mbi Kontrolluesin e të Dhënave</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Kjo Politikë Privatësie zbatohet për përpunimin e të dhënave personale në kuadër të platformës AlbMove, e operuar nga:
            </p>
            <ul className="list-none space-y-2 mb-6 bg-slate-50 rounded-xl p-6">
              <li className="flex items-center gap-3"><span className="font-semibold text-slate-700 w-40">Emri:</span> <span className="text-slate-600">C.S.M. Sh.p.k.</span></li>
              <li className="flex items-center gap-3"><span className="font-semibold text-slate-700 w-40">NIPT:</span> <span className="text-slate-600">M21612019M</span></li>
              <li className="flex items-center gap-3"><span className="font-semibold text-slate-700 w-40">Regjistruar më:</span> <span className="text-slate-600">12/04/2022, Tiranë</span></li>
              <li className="flex items-center gap-3"><span className="font-semibold text-slate-700 w-40">Administrator:</span> <span className="text-slate-600">Altin Shamku</span></li>
              <li className="flex items-center gap-3"><span className="font-semibold text-slate-700 w-40">Zyrë qendrore:</span> <span className="text-slate-600">Rruga Muçaj, Godina 1, 1032, Vorë, Tiranë, Shqipëri</span></li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-4">Në kuptim të:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Ligjit Nr. 9887/2008 "Për mbrojtjen e të dhënave personale", i ndryshuar</li>
              <li className="text-slate-600">Rregullores (BE) 2016/679 "General Data Protection Regulation" (GDPR), kur zbatohet</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">
              C.S.M. Sh.p.k. vepron si <strong>Kontrollues i të Dhënave</strong> (Data Controller).
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">2. Parimet e Përpunimit të të Dhënave</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Ne përpunojmë të dhënat personale në përputhje me nenin 5 të GDPR, duke respektuar:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
              <li className="text-slate-600">Ligjshmërinë, drejtësinë dhe transparencën</li>
              <li className="text-slate-600">Kufizimin e qëllimit</li>
              <li className="text-slate-600">Minimimin e të dhënave</li>
              <li className="text-slate-600">Saktësinë</li>
              <li className="text-slate-600">Kufizimin e ruajtjes</li>
              <li className="text-slate-600">Integritetin dhe konfidencialitetin</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">3. Kategoritë e të Dhënave që Mbledhim</h2>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">3.1 Të Dhëna Identifikuese</h3>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Emër dhe mbiemër</li>
              <li className="text-slate-600">Email</li>
              <li className="text-slate-600">Numër telefoni</li>
              <li className="text-slate-600">Dokument identiteti (kur kërkohet verifikim)</li>
              <li className="text-slate-600">NIPT (për bizneset)</li>
              <li className="text-slate-600">Adresë fizike</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">3.2 Të Dhëna Financiare</h3>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Informacion i kartës (i përpunuar nga ofrues të licencuar PSP)</li>
              <li className="text-slate-600">Historik transaksionesh</li>
              <li className="text-slate-600">Balanca e portofolit</li>
              <li className="text-slate-600">Informacion për rimbursime</li>
            </ul>
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-4">
              <p className="text-slate-700 font-medium">AlbMove nuk ruan të dhëna të plota të kartës së pagesës.</p>
            </div>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">3.3 Të Dhëna të Sesioneve të Karikimit</h3>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Data dhe ora e sesionit</li>
              <li className="text-slate-600">Vendndodhja e stacionit</li>
              <li className="text-slate-600">Energjia e konsumuar (kWh)</li>
              <li className="text-slate-600">Kohëzgjatja</li>
              <li className="text-slate-600">Çmimi</li>
              <li className="text-slate-600">Identifikuesi i karikuesit</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">3.4 Të Dhëna Teknike</h3>
            <ul className="list-disc pl-6 space-y-2 mb-6">
              <li className="text-slate-600">Adresë IP</li>
              <li className="text-slate-600">Device ID</li>
              <li className="text-slate-600">Version aplikacioni</li>
              <li className="text-slate-600">Sistemi operativ</li>
              <li className="text-slate-600">API logs</li>
              <li className="text-slate-600">WebSocket logs</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">4. Bazat Ligjore të Përpunimit (Neni 6 GDPR)</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Ne përpunojmë të dhënat mbi bazat e mëposhtme ligjore:</p>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">4.1 Ekzekutimi i Kontratës (Neni 6(1)(b) GDPR)</h3>
            <p className="text-slate-600 leading-relaxed mb-2">Për:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Krijimin e llogarisë</li>
              <li className="text-slate-600">Ofrimin e shërbimit të karikimit</li>
              <li className="text-slate-600">Procesimin e pagesave</li>
              <li className="text-slate-600">Gjenerimin e faturave</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">4.2 Detyrimi Ligjor (Neni 6(1)(c) GDPR)</h3>
            <p className="text-slate-600 leading-relaxed mb-2">Në përputhje me:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Ligjin Nr. 87/2019 për fiskalizimin</li>
              <li className="text-slate-600">Legjislacionin tatimor shqiptar</li>
              <li className="text-slate-600">Kërkesat e autoriteteve publike</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">4.3 Interes Legjitim (Neni 6(1)(f) GDPR)</h3>
            <p className="text-slate-600 leading-relaxed mb-2">Për:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Parandalimin e mashtrimit</li>
              <li className="text-slate-600">Sigurinë e sistemit</li>
              <li className="text-slate-600">Monitorimin e performancës</li>
              <li className="text-slate-600">Mbrojtjen e infrastrukturës OCPP</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">4.4 Pëlqimi (Neni 6(1)(a) GDPR)</h3>
            <p className="text-slate-600 leading-relaxed mb-2">Për:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Marketing</li>
              <li className="text-slate-600">Cookies analitike</li>
              <li className="text-slate-600">Komunikime promocionale</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">
              <strong>Pëlqimi mund të tërhiqet në çdo kohë.</strong>
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">5. Fiskalizimi dhe Raportimi Tatimor</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Në përputhje me Ligjin Nr. 87/2019 dhe aktet nënligjore, çdo transaksion:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Regjistrohet</li>
              <li className="text-slate-600">Fiskalizohet përmes sistemit DevPOS</li>
              <li className="text-slate-600">Raportohet tek administrata tatimore</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">
              Ky përpunim kryhet mbi bazën e detyrimit ligjor.
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">6. Ruajtja e të Dhënave</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Në përputhje me nenin 5(1)(e) GDPR:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600"><strong>Të dhënat e llogarisë:</strong> deri 5 vjet pas mbylljes</li>
              <li className="text-slate-600"><strong>Të dhënat fiskale:</strong> 10 vjet (detyrim ligjor)</li>
              <li className="text-slate-600"><strong>Logs teknike:</strong> 12 muaj</li>
              <li className="text-slate-600"><strong>Të dhënat e sesioneve:</strong> 3–5 vjet për analiza operacionale</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">
              Pas skadimit të afatit, të dhënat fshihen ose anonimizohen.
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">7. Siguria e të Dhënave (Neni 32 GDPR)</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Ne zbatojmë masa teknike dhe organizative duke përfshirë:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
              <li className="text-slate-600">Enkriptim TLS</li>
              <li className="text-slate-600">Enkriptim të të dhënave në server</li>
              <li className="text-slate-600">Autentikim me dy faktorë</li>
              <li className="text-slate-600">Kontroll aksesesh bazuar në role</li>
              <li className="text-slate-600">Monitorim të vazhdueshëm sigurie</li>
              <li className="text-slate-600">Backup të enkriptuar</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">8. Transferimi Ndërkombëtar i të Dhënave</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Të dhënat ruhen brenda BE-së. Në rast transferimi jashtë BE-së, zbatojmë:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-6">
              <li className="text-slate-600">Vendime adekuate të Komisionit Evropian</li>
              <li className="text-slate-600">Klauzola Standarde Kontraktuale (SCC) sipas nenit 46 GDPR</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">9. Web Analytics dhe Logs</h2>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">9.1 Google Analytics</h3>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Përdoret mbi bazë pëlqimi (neni 6(1)(a))</li>
              <li className="text-slate-600">IP anonimizohen kur është e aplikueshme</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">9.2 API & WebSocket Logs</h3>
            <p className="text-slate-600 leading-relaxed mb-2">Përdoren për:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Siguri</li>
              <li className="text-slate-600">Audit</li>
              <li className="text-slate-600">Diagnostikim</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">IP anonimizohen pas 30 ditësh.</p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">10. Cookies</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Përdorim:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li className="text-slate-600">Cookies esenciale</li>
              <li className="text-slate-600">Cookies analitike (me pëlqim)</li>
              <li className="text-slate-600">Cookies funksionale</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mb-6">
              Menaxhimi bëhet përmes banner-it të cookie-ve.
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">11. Të Drejtat Tuaja (Nenet 12–22 GDPR)</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Ju keni të drejtë për:</p>
            <div className="grid md:grid-cols-2 gap-4 mb-4">
              <div className="bg-slate-50 rounded-xl p-4">
                <p className="font-semibold text-slate-800">Akses (Neni 15)</p>
                <p className="text-sm text-slate-500">Të merrni kopje të të dhënave tuaja</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <p className="font-semibold text-slate-800">Korrigjim (Neni 16)</p>
                <p className="text-sm text-slate-500">Të korrigjoni të dhëna të pasakta</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <p className="font-semibold text-slate-800">Fshirje (Neni 17)</p>
                <p className="text-sm text-slate-500">"E drejta për tu harruar"</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <p className="font-semibold text-slate-800">Kufizim përpunimi (Neni 18)</p>
                <p className="text-sm text-slate-500">Të kufizoni përdorimin e të dhënave</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <p className="font-semibold text-slate-800">Portabilitet (Neni 20)</p>
                <p className="text-sm text-slate-500">Të merrni të dhënat në format dixhital</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <p className="font-semibold text-slate-800">Kundërshtim (Neni 21)</p>
                <p className="text-sm text-slate-500">Të kundërshtoni përpunimin</p>
              </div>
            </div>
            <p className="text-slate-600 leading-relaxed mb-6">
              <strong>Kërkesat shqyrtohen brenda 30 ditëve.</strong>
            </p>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">12. Ankesa</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Ju keni të drejtë të paraqisni ankesë pranë:
            </p>
            <div className="bg-slate-50 rounded-xl p-6 mb-6">
              <p className="font-semibold text-slate-800 mb-2">Komisioneri për të Drejtën e Informimit dhe Mbrojtjen e të Dhënave Personale</p>
              <p className="text-slate-600 flex items-center gap-2 mb-1">
                <MapPin className="w-4 h-4" />
                Rruga "Abdi Toptani", Nr. 5, Tiranë
              </p>
              <a href="https://www.idp.al" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline flex items-center gap-1">
                <ExternalLink className="w-4 h-4" />
                www.idp.al
              </a>
            </div>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">13. Zyrtari për Mbrojtjen e të Dhënave</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Për çdo çështje në lidhje me privatësinë:</p>
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-6">
              <p className="text-slate-700 flex items-center gap-2 mb-2">
                <Mail className="w-5 h-5 text-blue-600" />
                <a href="mailto:support@albmove.al" className="text-blue-600 hover:underline font-medium">support@albmove.al</a>
              </p>
              <p className="text-slate-700 flex items-center gap-2">
                <MapPin className="w-5 h-5 text-blue-600" />
                Rruga Muçaj, Godina 1, 1032, Vorë, Tiranë, Shqipëri
              </p>
            </div>
            
            <h2 className="text-2xl font-bold text-slate-900 font-['Inter_Tight'] mt-8 mb-4">14. Ndryshimet e Politikës</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              AlbMove rezervon të drejtën të përditësojë këtë politikë në përputhje me zhvillimet ligjore ose teknologjike.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">Ndryshimet materiale do të komunikohen përmes:</p>
            <ul className="list-disc pl-6 space-y-2 mb-8">
              <li className="text-slate-600">Email</li>
              <li className="text-slate-600">Njoftim në aplikacion</li>
              <li className="text-slate-600">Publikim në website</li>
            </ul>
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
